import React from 'react'

export default function SendIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.0068 10.9126C21.9762 11.38 21.9762 12.7603 21.0068 13.2276L4.84583 21.0094C3.79719 21.5135 2.67147 20.4755 3.08937 19.3901L5.61587 12.8204L11.3074 12.8196C11.5016 12.8128 11.6855 12.7308 11.8205 12.591C11.9555 12.4512 12.0309 12.2644 12.0309 12.0701C12.0309 11.8758 11.9555 11.689 11.8205 11.5492C11.6855 11.4094 11.5016 11.3274 11.3074 11.3206L5.61587 11.3199L3.08937 4.75014C2.67218 3.66403 3.79789 2.62741 4.84583 3.13087L21.0068 10.9126Z" fill="#B1AEC7"/>
        </svg>
    )
}
